{
  "ANY": {
    "primary": {
      "label": "",
      "data": {
        "details": {
          "SRC": "ANY",
          "Label": "Details",
          "Overview": false,
          "Overview Label": false,
          "Overview Detail": true,
          "Overview Detail Label": false,
          "Show missing": false,
          "Primary": true,
          "Hidden": false
        }
      }
    },
    "others": {
      "data": {
        "@timestamp": {
          "SRC": "ANY",
          "Label": "@Timestamp",
          "Type": "Timestamp",
          "Overview": false,
          "Overview Label": false,
          "Overview Detail": false,
          "Overview Detail Label": false,
          "Show missing": false,
          "Primary": false,
          "Hidden": true
        },
        "timestamp": {
          "SRC": "ANY",
          "Label": "Timestamp",
          "Type": "Timestamp",
          "Overview": true,
          "Overview Label": false,
          "Overview Detail": false,
          "Overview Detail Label": false,
          "Show missing": false,
          "Primary": false,
          "Hidden": false
        },
        "level": {
          "SRC": "ANY",
          "Label": "Level",
          "Overview": true,
          "Overview Label": true,
          "Overview Detail": false,
          "Overview Detail Label": false,
          "Show missing": true,
          "Primary": false,
          "Hidden": false
        },
        "ingestSequence": {
          "SRC": "ANY",
          "Label": "Ingest Sequence",
          "Overview": false,
          "Overview Label": false,
          "Overview Detail": false,
          "Overview Detail Label": false,
          "Show missing": false,
          "Primary": false,
          "Hidden": false
        },
        "ingestTopic": {
          "SRC": "ANY",
          "Label": "Ingest Topic",
          "Overview": false,
          "Overview Label": false,
          "Overview Detail": false,
          "Overview Detail Label": false,
          "Show missing": false,
          "Primary": false,
          "Hidden": true
        },
        "@version": {
          "SRC": "ANY",
          "Label": "Version",
          "Overview": false,
          "Overview Label": false,
          "Overview Detail": false,
          "Overview Detail Label": false,
          "Show missing": false,
          "Primary": false,
          "Hidden": false
        },
        "accessDomains": {
          "SRC": "ANY",
          "Label": "Access Domains",
          "Overview": false,
          "Overview Label": false,
          "Overview Detail": false,
          "Overview Detail Label": false,
          "Show missing": false,
          "Primary": false,
          "Hidden": true
        },
        "terminalDomain": {
          "SRC": "ANY",
          "Label": "Terminal Domain",
          "Overview": false,
          "Overview Label": false,
          "Overview Detail": false,
          "Overview Detail Label": false,
          "Show missing": false,
          "Primary": false,
          "Hidden": false
        },
        "type": {
          "SRC": "ANY",
          "Label": "Type",
          "Overview": false,
          "Overview Label": false,
          "Overview Detail": false,
          "Overview Detail Label": false,
          "Show missing": false,
          "Primary": false,
          "Hidden": true
        },
        "ingestTime": {
          "SRC": "ANY",
          "Label": "Ingest Time",
          "Type": "Timestamp",
          "Overview": false,
          "Overview Label": false,
          "Overview Detail": false,
          "Overview Detail Label": false,
          "Show missing": false,
          "Primary": false,
          "Hidden": false
        },
        "message": {
          "SRC": "ANY",
          "Label": "Message",
          "Overview": true,
          "Overview Label": false,
          "Overview Detail": false,
          "Overview Detail Label": false,
          "Show missing": false,
          "Primary": false,
          "Hidden": false
        }
      }
    }
  }
}
